import React from "react";

// Payment method logos: iyzico, Visa, Mastercard. SVG inline so no external CDN dependency.
export function IyzicoLogo({ className = "" }) {
  return (
    <svg viewBox="0 0 120 32" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="iyzico ile Öde">
      <rect x="0" y="0" width="120" height="32" rx="4" fill="#1E64FF" />
      <text x="60" y="21" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="700" fill="#ffffff" letterSpacing="0.5">
        iyzico ile Öde
      </text>
    </svg>
  );
}

export function VisaLogo({ className = "" }) {
  return (
    <svg viewBox="0 0 120 40" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Visa">
      <rect x="0" y="0" width="120" height="40" rx="4" fill="#1A1F71" />
      <text x="60" y="27" textAnchor="middle" fontFamily="Arial Black, sans-serif" fontSize="18" fontWeight="900" fontStyle="italic" fill="#F7B600" letterSpacing="1">
        VISA
      </text>
    </svg>
  );
}

export function MastercardLogo({ className = "" }) {
  return (
    <svg viewBox="0 0 120 40" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Mastercard">
      <rect x="0" y="0" width="120" height="40" rx="4" fill="#ffffff" />
      <circle cx="48" cy="20" r="11" fill="#EB001B" />
      <circle cx="68" cy="20" r="11" fill="#F79E1B" />
      <path
        d="M58 11.5a11 11 0 010 17 11 11 0 010-17z"
        fill="#FF5F00"
      />
      <text x="60" y="37" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="5" fontWeight="700" fill="#1A1F36" letterSpacing="0.3">
        mastercard
      </text>
    </svg>
  );
}

export default function PaymentBadges({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <IyzicoLogo className="h-8 w-auto" />
      <VisaLogo className="h-8 w-auto" />
      <MastercardLogo className="h-8 w-auto" />
    </div>
  );
}
